import { render, staticRenderFns } from "./DesignHub.vue?vue&type=template&id=ead652d0&scoped=true"
import script from "./DesignHub.vue?vue&type=script&lang=js"
export * from "./DesignHub.vue?vue&type=script&lang=js"
import style0 from "./DesignHub.vue?vue&type=style&index=0&id=ead652d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead652d0",
  null
  
)

export default component.exports